import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import sellerService from '../services/seller.service';
import { setMessage } from './message';
export const fetchSellerList = createAsyncThunk(
    'seller/fetchSellerList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await sellerService.getSellerList(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data, count, totalPages, etc. }
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

export const fetchSellerDropdown = createAsyncThunk(
    'seller/fetchSellerDropdown',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await sellerService.getSellerDropdown(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data, count, totalPages, etc. }
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);
export const fetchArchivedSellerList = createAsyncThunk(
    'seller/fetchArchivedSellerList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await sellerService.getSellerArchiveList(page, pagesize, search, ordering);
            return response.data; // Assuming response contains { data, count, totalPages, etc. }
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
            
        }
    },
);
export const createSeller = createAsyncThunk(
    'seller/createSeller',
    async (sellerData, thunkAPI) => {
        try {
            const response = await sellerService.addSeller(sellerData);
            return response.data; // Assuming response contains the created die group data
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);
export const updateSeller = createAsyncThunk(
    'seller/updateSeller',
    async ({ id, values }, thunkAPI) => {
        try {
            const response = await sellerService.updateSeller(id, values);
            thunkAPI.dispatch(fetchSellerList({ page: 1, limit: 10 })); // Re-fetch list after update
            return response.data; // Return the updated die group data
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);

export const deleteSeller = createAsyncThunk(
    'seller/deleteSeller',
    async (id, thunkAPI) => {
        try {
            await sellerService.deleteSeller(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);

export const unArchiveSeller = createAsyncThunk(
    'seller/unArchiveSeller',
    async (id, thunkAPI) => {
        try {
            await sellerService.unArchiveSeller(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

const initialState = {
    data: [],
    list: [],
    loading: false,
    totalpage: 0,
    currentPage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    hasMore: true,
};

const sellerSlice = createSlice({
    name: 'seller',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetSellerList: state => {
            state.list = []; // This will clear the list
        },
        resetCurrentSellerPage: state => {
            state.currentPage = 1;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchSellerList.pending, state => {
                state.status = 'pending';
                state.loading = true;
            })
            .addCase(fetchSellerList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.loading = false;
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; 
                state.totalRecord = action.payload.count || 0;
                state.totalpage = action.payload.totalPages || 0;
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchSellerList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(fetchSellerDropdown.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchSellerDropdown.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; // Adjust this to match your API response
                state.totalRecord = action.payload.count || 0;
                state.totalpage = action.payload.totalPages || 0;
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchSellerDropdown.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });


        builder
            .addCase(fetchArchivedSellerList.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedSellerList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; // Adjust this to match your API response
                state.totalRecord = action.payload.count || 0;
                state.totalpage = action.payload.totalPages || 0;
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedSellerList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.data =  []; 
                state.list =  [];  
                state.error = action.error.message;
            });
        builder
            .addCase(createSeller.pending, state => {
                state.status = 'loading';
            })
            .addCase(createSeller.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createSeller.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(updateSeller.pending, state => {
                state.status = 'loading';
            })
            .addCase(updateSeller.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const updatedGroup = action.payload;
                const index = state.data.findIndex(
                    group => group.id === updatedGroup.id,
                ); // Find the index of the updated group
                if (index !== -1) {
                    state.data[index] = updatedGroup; // Replace the old group with the updated one
                }
            })
            .addCase(updateSeller.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(deleteSeller.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteSeller.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteSeller.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchiveSeller.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveSeller.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveSeller.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetSellerList, resetCurrentSellerPage } = sellerSlice.actions;
const { reducer } = sellerSlice;
export default reducer;
